import React from 'react';
import Content from '../dashboard/Content';
import sensorService from '../../services/sensor-service';
import userService from '../../services/user-service';
import templateService from '../../services/template-service';
import { Select } from '../widgets';
import { Checkbox } from '../widgets/beauty/input';
import { getCurrentUser } from '../../utils/auth';
import alert, { errorAlert } from '../../utils/alert';
import ChooseTemplateDialog from '../template/ChooseTemplateDialog';
import Dialog from '../../toolkit/dialog';

const { Option } = Select;

export interface CreateSensorProps {
  mode: 'admin' | 'customer';
}


export default class CreateSensor extends React.Component<CreateSensorProps> {

  state = {
    mode: null,
    serial: null,
    multi: false,
    userId: null,
    customers: [],
    templates: [],
    templateId: null,
    fields: [],
    submiting: false
  }

  render() {
    return (
      <Content title="افزودن سنسور جدید">
        <div className="create-sensor-component">
          <div className="row">
            <div className="col-12">
              {this.renderContent()}
            </div>
          </div>
        </div>
      </Content>
    );
  }

  componentDidMount = async () => {
    const token = getCurrentUser();
    const mode = token.access === 'admin' ? 'admin' : 'customer';
    let userId, customers;
    const templates = await templateService.fetch();
    const update: any = { mode, templates };
    if (mode === 'admin') {
      userId = null;
      customers = await userService.listCustomers();
    }
    else {
      userId = token._id;
      customers = [];
    }
    update.customers = customers;
    update.userId = userId;
    this.setState(update);
  }

  private renderContent = () => {
    switch (this.state.mode) {
      case 'admin':
      case 'customer':
        return this.renderForm();
      case null:
        return this.renderLoading();
    }
  }

  private renderLoading = () => {
    return (
      <div className="row">
        <div className="col-6 mx-auto">
          <div className="alert alert-primary">
            در حال بارگذاری اطلاعات
          </div>
        </div>
      </div>
    );
  }

  private renderForm = () => {
    const { templates, templateId, customers, userId, submiting } = this.state;
    const template = templates.find(t => t._id === templateId);
    return (
      <div className="row text-center">
        <div className="col-xl-4 col-lg-5 col-12 mb-3 mx-auto mt-4">
          <input
            type="text"
            className="form-control text-right mb-3 ltr"
            placeholder="سریال سنسور"
            onChange={this.handleSerialChange} />
          <div style={{ margin: '1rem 0' }}>
            <button
              onClick={this.handleTemplateClicked}
              className="ant-btn ant-btn-lg btn-block text-right">
              انتخاب الگو -
              {template == null ? ' انتخاب نشده ' : ' ' + template.name}
            </button>
          </div>
          {(this.state.mode !== 'admin' ? '' :
            <>
              <Select
                style={{ margin: '1rem 0' }}
                value={userId}
                onChange={this.handleUserSelect}>
                <Option value={null}>انتخاب کاربر</Option>
                {customers.map(item => (
                  <Option key={item._id} value={item._id}>{item.name}</Option>
                ))}
              </Select>
            </>
          )}
          <div className="ml-auto d-flex">
            <Checkbox
              text="درج به صورت گروهی"
              checked={this.state.multi}
              onChange={this.handleMultiChange}
            />
          </div>
          <button
            {...(submiting ? { disabled: true } : {})}
            style={{ fontSize: '1rem' }}
            onClick={this.handleSubmitButtonClick}
            className="btn ant-btn btn-block ant-btn-primary mt-4">افزودن سنسور</button>
        </div>
      </div>
    );
  }

  private handleSerialChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ serial: e.target.value });
  }

  private handleUserSelect = (userId: string) => this.setState({ userId });

  private handleMultiChange = () => this.setState({ multi: !this.state.multi });

  private handleTemplateClicked = () => {
    new Dialog({
      rtl: true,
      size: 'small',
      showTitle: false,
      message: ChooseTemplateDialog,
      onResolve: this.handleTemplateChoosed
    }).show({
      skipConfirm: true,
      askRecursive: false,
      group: null
    });
  }

  private handleTemplateChoosed = ({ fields, templateId }) => {
    this.setState({ fields, templateId });
  }

  private handleSubmitButtonClick = async () => {
    const { userId, templateId, multi, fields } = this.state;
    const serial = this.state.serial;
    if (!serial || serial.trim().length === 0) {
      return errorAlert('سریال فیلد اجباری است').show();
    }
    if (userId == null) {
      return errorAlert('فیلد کاربر یک فیلد اجباری است').show();
    }
    try {
      this.setState({ submiting: true });
      await sensorService.updateUser(serial, {
        userId,
        fields,
        templateId,
        multiSensor: multi
      });
      alert({
        type: 'success',
        message: `سنسور ${serial} به لیست سنسورهای شما اضافه شد.`,
        buttonText: 'باشه'
      }).show()
    }
    catch (e) {
      if (e.response && e.response.data && e.response.data.message) {
        errorAlert(e.response.data.message).show();
      }
    }
    this.setState({ submiting: false });
  }

}
